
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/HomeHeroCarousel.css";

// Hardcoded event banners — replace with your actual image paths
const HARDCODED_EVENTS = [
  {
    id: 1,
    title: "Conference",
    image: "/Hero_banners/conference.png",
  },
  {
    id: 2,
    title: "Meetup",
    image: "/Hero_banners/meetup.png",
  },
  {
    id: 3,
    title: "Expo",
    image: "/Hero_banners/Expo.png",
  },
  {
    id: 4,
    title: "marathon",
    image: "/Hero_banners/conference.png",
  },
  {
    id: 5,
    title: "Event",
    image: "/Hero_banners/event.png",
  },
  {
    id: 6,
    title: "workshop",
    image: "/Hero_banners/workshop.png",
  },
  {
    id: 7,
    title: "Community Conference",
    image: "/Hero_banners/marathon.png",
  },
];

const HomeHeroCarousel = () => {
  const [events] = useState(HARDCODED_EVENTS);
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  const navigate = useNavigate();

  // ---------- Auto rotate (pauses on hover) ----------
  useEffect(() => {
    if (events.length < 2 || paused) return;

    const timer = setInterval(() => {
      setActiveIndex((current) => (current + 1) % events.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [events.length, paused]);

  const move = (offset) => {
    if (events.length < 2) return;

    setActiveIndex(
      (current) => (current + offset + events.length) % events.length
    );
  };

  // ---------- Build the visible cards (-2 to +2) ----------
  const getVisibleCards = () => {
    const n = events.length;

    const positions = {
      "-2": "far-left",
      "-1": "left",
      "0": "center",
      "1": "right",
      "2": "far-right",
    };

    const used = new Set();
    const cards = [];

    [0, -1, 1, -2, 2].forEach((offset) => {
      if (n < 2 && offset !== 0) return;

      const index = ((activeIndex + offset) % n + n) % n;

      if (used.has(index)) return;
      used.add(index);

      cards.push({
        event: events[index],
        index,
        position: positions[offset],
      });
    });

    return cards;
  };

  const handleCardClick = (event, position) => {
    if (position === "left" || position === "far-left") {
      move(-1);
    } else if (position === "right" || position === "far-right") {
      move(1);
    } else if (event.id != null) {

    }
  };

  // ---------- Render carousel ----------
  return (
    <div
      className="ef-hero-banner-carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="ef-hero-banner-stage">
        {getVisibleCards().map(({ event, index, position }) => (
          <button
            type="button"
            key={event.id ?? `${event.title}-${index}`}
            className={`ef-hero-banner-card ${position}`}
            aria-label={`View event: ${event.title}`}
            tabIndex={position === "center" ? 0 : -1}
            onClick={() => handleCardClick(event, position)}
          >
            <img
              src={event.image}
              alt={event.title}
              className="ef-hero-banner-image"
              loading={position === "center" ? "eager" : "lazy"}
              draggable="false"
            />
          </button>
        ))}
      </div>
      <div className="ef-hero-banner-dots">
        {[0, 1, 2].map((dot) => (
          <button
            key={dot}
            type="button"
            className={`ef-hero-banner-dot ${activeIndex % 3 === dot ? "active" : ""
              }`}
            onClick={() => setActiveIndex(dot % events.length)}
            aria-label={`Go to banner ${dot + 1}`}
          />
        ))}
      </div>



    </div>
  );
};

export default HomeHeroCarousel;
